import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconEmail2"><Path d="M2.75 4C2.33579 4 2 4.33579 2 4.75V6.78938L12 11.8211L22 6.78937V4.75C22 4.33579 21.6642 4 21.25 4H2.75Z" fill="currentColor"/><Path d="M22 8.46857L12.3371 13.3307C12.125 13.4374 11.8749 13.4374 11.6629 13.3307L2 8.46857V19.25C2 19.6642 2.33579 20 2.75 20H21.25C21.6642 20 22 19.6642 22 19.25V8.46857Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2;
